import type { MockCache, ActivityEvent } from '../../types';

import {
  checklistSetAssigneeWishes,
  commentAddWishes,
  commentSetAssigneeWishes,
  messageWishes,
} from './discussion-wishes';
import {
  taskMoveWishes,
  taskSetAssigneeWishes,
  taskSetDatesWishes,
  taskSetDescriptionWishes,
  taskSetEstimateWishes,
  taskSetLabelsWishes,
  taskSetMilestoneWishes,
  taskSetPriorityWishes,
  taskSetStatusWishes,
  taskSetTitleWishes,
  taskSetTypeWishes,
} from './task-wishes';
import { deliver } from '../inbox-delivery';
import type { InboxWish } from '../inbox-delivery';
import { requireCache } from '../runtime';

export interface FanoutContext {
  cache: MockCache;
  event: ActivityEvent;
  after: Record<string, unknown>;
  wishes: InboxWish[];
}

const WISH_COLLECTORS: Partial<Record<string, (context: FanoutContext) => void>> = {
  'task.setStatus': taskSetStatusWishes,
  'task.setAssignee': taskSetAssigneeWishes,
  'task.setMilestone': taskSetMilestoneWishes,
  'task.setTitle': taskSetTitleWishes,
  'task.setDescription': taskSetDescriptionWishes,
  'task.setPriority': taskSetPriorityWishes,
  'task.setEstimate': taskSetEstimateWishes,
  'task.setDates': taskSetDatesWishes,
  'task.setLabels': taskSetLabelsWishes,
  'task.setType': taskSetTypeWishes,
  'task.move': taskMoveWishes,
  'comment.setAssignee': commentSetAssigneeWishes,
  'checklist.setAssignee': checklistSetAssigneeWishes,
  'comment.add': commentAddWishes,
  'message.send': messageWishes,
  'message.reply': messageWishes,
};

export function fanout(event: ActivityEvent): void {
  const cache = requireCache();
  const after = event.after ?? {};
  const wishes: InboxWish[] = [];
  WISH_COLLECTORS[event.mutator]?.({ cache, event, after, wishes });
  deliver(cache, event.actorId, wishes);
}

export function fanoutLast(cache: MockCache): void {
  const event = cache.activity[cache.activity.length - 1];
  if (event !== undefined) {
    fanout(event);
  }
}
